import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { setPageTitle } from '../../../redux/title/title.slice';
import { getAdvisorsForProvider } from '../../../redux/providers/providers.slice';

import Loader from '../../../components/ui/loader';
import { FTable, FTableCell } from '../../../components/ui/table';

export default function ProviderAdvisors() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { providers, providerAdvisors, loading, loadingAdvisors } = useSelector(
    (state) => state.providers
  );

  // Find provider from list
  const provider = useMemo(() => {
    return providers?.find((p) => p.id === id);
  }, [providers, id]);

  // Fetch provider advisors
  useEffect(() => {
    if (id) {
      dispatch(getAdvisorsForProvider(id));
    }
  }, [dispatch, id]);

  // Set page title
  useEffect(() => {
    if (provider) {
      dispatch(setPageTitle(provider.friendlyName || provider.clientName));
    }
  }, [dispatch, provider]);

  if (loading || loadingAdvisors) {
    return <Loader loading={true} message="Loading advisors..." />;
  }

  const columns = [{ label: 'Code' }, { label: 'Advisor' }];

  return (
    <FTable
      title="Advisors"
      columns={columns}
      rows={providerAdvisors}
      emptyMessage="No provider advisors found"
      renderRow={(advisor) => (
        <>
          <FTableCell>{advisor.partnerCode || '—'}</FTableCell>
          <FTableCell>{advisor.partnerName || '—'}</FTableCell>
        </>
      )}
    />
  );
}
